import React from "react";
import { Select, FormControl, InputLabel } from "@mui/material";
import { Controller } from "react-hook-form";
import { StyledSelect } from "./Select.style";

const ReactHookFormSelect = (props) => {
  return (
    <FormControl fullWidth size={props.size ?? "medium"}>
      <InputLabel id={"select-label" + props.id}>{props.title}</InputLabel>
      <Controller
        render={({ field }) => (
          <StyledSelect
            value={field.value}
            width={props.width}
            onChange={(e) => {
              field.onChange(e);
              props.onChange && props.onChange(e.target.value);
            }}
            inputRef={field.ref}
            fullWidth
            labelId={"select-label" + props.id}
            label={props.label}
            variant={props.variant ?? "outlined"}
          >
            {props.children}
          </StyledSelect>
        )}
        name={props.id}
        control={props.control}
        defaultValue={props.defaultValue ?? ""}
      />
    </FormControl>
  );
};
export default ReactHookFormSelect;
